import InventoryTransactionPage from "../../InventoryTransactionPage";

const InventoryTransferIn = () => <InventoryTransactionPage title="Transfer In" step={3} description="Receive inventory transferred from another warehouse or branch." />;

export default InventoryTransferIn;
